import React from "react"

const TaggrNoticeBackground = () => {
  return <header className="taggrHeaderMain">
  </header>
}

export default TaggrNoticeBackground